import { InfoRowTypes } from './types';

import cn from './styles.module.css';

const InfoRow = ({
  title,
  children,
  id,
  borderless,
  className,
  lessPadding,
  style,
  withoutPadding,
}: InfoRowTypes) => (
  <div
    className={`${cn.stepBlockInputWrapper} ${
      borderless ? cn.stepBlockInputWrapperBorderless : ''
    } ${className || ''} ${lessPadding ? cn.lessPadding : ''} ${withoutPadding ? cn.withoutPadding : ''}`}
    id={id}
    style={style}
  >
    <div className={cn.stepBlockInputTitle}>{title}</div>
    <div className={cn.stepBlockInput}>{children}</div>
  </div>
);

export default InfoRow;
